import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { PARAM_SORT, PARAM_SORT_TYPE } from '../../../constants'

import { StoresContext } from '../../../provider/StoreProvider'

import { useUserInfo } from '../../../hooks/useUserInfo'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Button } from '../../../components/button'
import { Chip } from '../../../components/chip'
import { Header } from '../../../components/header'
import { Sort } from '../../../components/paramOption/Sort'
import { Text } from '../../../components/text'
// import { ExchangePoint } from './ExchangePoint'
// import { ExchangeGiftCard } from './ExchageGiftCard'

interface DateFilter {
  title: string
  type: 'WEEK' | 'MONTH' | '3MONTH' | '6MONTH' | 'YEAR' | '2YEAR'
}

const DATE_FILTER: DateFilter[] = [
  { title: '1주일', type: 'WEEK' },
  { title: '1개월', type: 'MONTH' },
  { title: '3개월', type: '3MONTH' },
  { title: '6개월', type: '6MONTH' },
  { title: '1년', type: 'YEAR' },
  { title: '2년', type: '2YEAR' },
]

const FILTER_LIST: { title: string; type: PARAM_SORT_TYPE }[] = [
  { title: '전체', type: 'ALL' },
  { title: '적립 내역', type: 'SAVE' },
  { title: '전환 내역', type: 'CHANGE' },
  { title: '소멸 내역', type: 'EXTINCTION' },
]

const POINT_LIST: { title: string; type: PARAM_SORT_TYPE }[] = [
  { type: 'SAVE', title: '분할구매적립' },
  { type: 'CHANGE', title: '예치금으로전환' },
  { type: 'EXTINCTION', title: '유효기간만료' },
  { type: 'SAVE', title: '분할구매적립' },
]

export function Point() {
  const { commonStore } = useContext(StoresContext)

  const [, setActiveDateFilter] = useState<DateFilter['type']>('WEEK')
  const [sortType, setSortType] = useState<PARAM_SORT_TYPE>(PARAM_SORT['ALL'])

  const { data: userInfo } = useUserInfo()

  useEffect(() => {
    commonStore.setShowTab(false)
  }, [])

  return (
    <Wrap>
      <Header type="SUB" title="포인트" />
      <Content>
        <Container>
          <PersonalPointContainer>
            <HoldPointContainer>
              <Text size={16} weight={500}>
                <Text size={16} weight={700}>
                  {userInfo?.name}
                </Text>
                님의 보유 A-포인트
              </Text>
              <Text size={24} weight={700}>
                {(10000).toLocaleString()}P
              </Text>
              <div>
                <Link to="">
                  {/* <ExchangePoint /> */}
                  <Button>A-머니 전환하기</Button>
                </Link>
                <Link to="">
                  {/* <ExchangeGiftCard /> */}
                  <Button>상품권 전환하기</Button>
                </Link>
              </div>
            </HoldPointContainer>
            <PointScheduleContainer>
              <PointSchedule>
                <Text size={14} weight={500}>
                  적립 예정 A-포인트
                </Text>
                <Text size={18} weight={700}>
                  {(1000).toLocaleString()}P
                </Text>
              </PointSchedule>
              <PointSchedule>
                <Text size={14} weight={500}>
                  당월 소멸 예정 A-포인트
                </Text>
                <Text size={18} weight={700}>
                  {(1000).toLocaleString()}P
                </Text>
              </PointSchedule>
            </PointScheduleContainer>
          </PersonalPointContainer>
          <FilterContainer>
            {DATE_FILTER.map(({ title, type }) => {
              const handleActiveDateType = () => setActiveDateFilter(type)

              return (
                <Chip key={type} onClick={handleActiveDateType}>
                  {title}
                </Chip>
              )
            })}
          </FilterContainer>
          <ListHeader>
            {dayjs().subtract(1, 'week').format('YYYY.MM.DD')} ~ {dayjs().format('YYYY.MM.DD')}
            <Sort sortType={sortType} sortList={FILTER_LIST} setSortType={(type) => setSortType(type)} />
          </ListHeader>
          <div>
            {POINT_LIST.map(({ title, type }, index) => {
              const getType = () => {
                switch (type) {
                  case 'SAVE': {
                    return '적립'
                  }
                  case 'CHANGE': {
                    return '전환'
                  }
                  case 'EXTINCTION': {
                    return '소멸'
                  }
                }
              }
              const isIncrement = type === 'SAVE'
              const color = isIncrement ? 'secondary_5' : 'error'
              return (
                <div key={index}>
                  <label>
                    <RowBetween>
                      <ColumnContainer>
                        <Text size={14} weight={500}>
                          {title}
                        </Text>
                        <Text size={14} weight={500}>
                          {dayjs().format('YYYY.MM.DD HH:mm:ss')}
                        </Text>
                      </ColumnContainer>
                      <ColumnContainer>
                        <Text size={14} weight={700} color={color}>
                          {isIncrement ? '+' : '-'}
                          {(10000).toLocaleString()}
                        </Text>
                        <Text size={14} weight={500}>
                          {getType()}
                        </Text>
                      </ColumnContainer>
                    </RowBetween>
                  </label>
                </div>
              )
            })}
          </div>
        </Container>
      </Content>
    </Wrap>
  )
}
const Container = styled.div`
  padding: 24px;
`

const RowBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const PersonalPointContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const HoldPointContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const PointScheduleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  margin: 16px 0;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
`

const PointSchedule = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 50%;
  flex-grow: 0;
  width: 100%;
  padding: 8px;
`

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  > div {
    flex-grow: 0;
    width: calc(100% / ${DATE_FILTER.length} - 8px);
    min-width: 50px;
    max-height: 24px;
    padding: 3px 0;
  }
`

const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  height: 20px;
  ion-select {
    min-height: 0;
  }
`

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`
